<template>
    <!-- <div style="padding-top:-2px;margin-top:-2px;">
      <v-label>
        <b>{{ label }} </b>
        </v-label>  
    </div> -->
    <div > 
        <v-label>
        <b>{{ label }} </b>
        </v-label> 
        <v-text-field
            ref="field"
            v-model="formattedValue"
            outlined
            dense
            hide-details="auto"
            :readonly="readonly"
            @input="updateValue"
            @keyup.enter="$emit('keyupEnter', $event); $emit('keyup.enter', $event); $emit('submit', $event)"
            @keydown.enter="$emit('keydownEnter', $event); $emit('keydown.enter', $event)"
            :disabled="disabled"
            :error="hasError"
            :error-messages="errorMessage"
        />
    </div>
</template>

<script>
import AutoNumeric from "autonumeric";

export default {
  name: "SMoneyInput",
  props: {
    value: { type: [String, Number], default: "" }, // Compatible con número y string
    label: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
        autoNumericInstance: null,
        hasError: false,
        errorMessage: "",
    };
  },
  computed: {
    formattedValue: {
      get() {
        return this.value?.toString() || "";
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    updateValue(event) {
      this.hasError = false;
      this.errorMessage = "";
      const rawValue = this.autoNumericInstance?.getNumber() || event;
      this.$emit("input", rawValue);
    },
    focus() {
      this.$refs.field?.focus?.();
    },
    error(msg) {
      this.hasError = true;
      this.errorMessage = msg || "Campo obligatorio";
      this.$nextTick(() => {
        this.focus();
      });
    },
  },
  mounted() {
    this.autoNumericInstance = new AutoNumeric(this.$refs.field.$refs.input, {
      decimalCharacter: ".",
      digitGroupSeparator: ",",
      minimumValue: "0",
      modifyValueOnWheel: false
    });
   //new AutoNumeric(this.$refs.field.$refs.input);
  },
  
  
};
</script>